import { BranchInformational } from '@components/RouteComponents'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_initialized/branchInformational')({
  component: () => <BranchInformational />,
})
